// DS: CO0.1M
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import Sticky from '@wix/da-ds/pkg/Sticky';
import MobileSubmissionDetailsHeader from '../../../SubmissionDetails/MobileSubmissionDetailsHeader';
import SiteHeader from '../../../SiteHeader';
import { useDuperbrowseViewType } from '../../../Duperbrowse/DuperbrowseViewContext';

export interface Props {}

const DeviationPageHeader: React.FC<Props> = () => {
  const isMobile = useContext(MobileContext);
  const { isInDuperbrowse } = useDuperbrowseViewType();
  const { isLoggedIn } = useContext(SessionContext);

  if (!isMobile) {
    return <SiteHeader />;
  }

  if (isInDuperbrowse && isLoggedIn) {
    return (
      <Sticky marginTop={-1}>
        {isStuck => (
          <MobileSubmissionDetailsHeader isSticky={true} isStuck={isStuck} />
        )}
      </Sticky>
    );
  }

  return (
    <>
      <SiteHeader />
      <MobileSubmissionDetailsHeader isSticky={false} />
    </>
  );
};
DeviationPageHeader.displayName = 'DeviationPageHeader';

export default DeviationPageHeader;
